const TableHeader = ({ headers }) => {
    return (
      <thead className="bg-gray-100 text-center">
       <tr>
  {headers.map((header, index) => (
    <th 
      key={index}
      className="py-3 px-5 border-b text-center text-sm sm:text-base font-normal"
    >
      {header }

    </th>
  ))}
</tr>

      </thead>
    );
  };
  
  export default TableHeader;
  